export const PRIORITIES = [
  { key: "wysoki", name: "Wysoki", skrot: "WYSOKI", kolor: "#F08A80" },
  { key: "sredni", name: "Średni", skrot: "ŚREDNI", kolor: "#E0A45C" },
  { key: "niski", name: "Niski", skrot: "NISKI", kolor: "#878787" },
];

export const priorityName = (key) =>
  PRIORITIES.find((p) => p.key === key)?.name || key || "—";

export const priorityShort = (key) =>
  PRIORITIES.find((p) => p.key === key)?.skrot || (key || "").toUpperCase();

export const priorityColor = (key) =>
  PRIORITIES.find((p) => p.key === key)?.kolor || "#878787";
